export const CMS_USER_ROLES = {
  WORKSPACE_ADMIN: 'workspace_admin',
  WORKSPACE_READ: 'workspace_read',
  WORKSPACE_WRITE: 'workspace_write',
  WORKSPACE_DELETE: 'workspace_delete',

  FILE_READ: 'file_read',
  FILE_WRITE: 'file_write',
  FILE_DELETE: 'file_delete',
  FOLDER_READ: 'folder_read',
  FOLDER_WRITE: 'folder_write',
  FOLDER_DELETE: 'folder_delete',
};
export const MENU_PATHS = {
  'account-information': 'account-information',
  'manage-permission': 'manage-permission',
  'manage-templates': 'manage-templates',
  'ai-conversation-analytics': 'ai-conversation-analytics',
  'manage-profile': 'manage-profile',
};

export const genWorkspaceHeader = (id) => {
  return { 'X-Workspace': id };
};
export const ONEDOC = 'OneDoc';
export const CMS_USER_ROLES_DISPLAY = {
  [CMS_USER_ROLES.WORKSPACE_ADMIN]: { label: 'Workspace admin', value: CMS_USER_ROLES.WORKSPACE_ADMIN },
  [CMS_USER_ROLES.WORKSPACE_READ]: { label: 'Workspace read', value: CMS_USER_ROLES.WORKSPACE_READ },
  [CMS_USER_ROLES.WORKSPACE_WRITE]: { label: 'Workspace write', value: CMS_USER_ROLES.WORKSPACE_WRITE },
  [CMS_USER_ROLES.WORKSPACE_DELETE]: { label: 'Workspace delete', value: CMS_USER_ROLES.WORKSPACE_DELETE },

  [CMS_USER_ROLES.FOLDER_READ]: { label: 'Folder read', value: CMS_USER_ROLES.FOLDER_READ },
  [CMS_USER_ROLES.FOLDER_WRITE]: { label: 'Folder write', value: CMS_USER_ROLES.FOLDER_WRITE },
  [CMS_USER_ROLES.FOLDER_DELETE]: { label: 'Folder delete', value: CMS_USER_ROLES.FOLDER_DELETE },

  [CMS_USER_ROLES.FILE_READ]: { label: 'File read', value: CMS_USER_ROLES.FILE_READ },
  [CMS_USER_ROLES.FILE_WRITE]: { label: 'File write', value: CMS_USER_ROLES.FILE_WRITE },
  [CMS_USER_ROLES.FILE_DELETE]: { label: 'File delete', value: CMS_USER_ROLES.FILE_DELETE },
};

export const OPENAPI_STATUS = {
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  REMOVED: 'REMOVED',
};
export const _1MG_DOMAIN = '1mg.com';
export const COLOR_THEME = 'colorTheme';

// Tab key to type mapping
export const WORKSPACE_TYPE_MAP = {
  1: 'All',
  2: 'SERVICE',
  3: 'TEAM',
  4: 'PROJECT',
  5: 'PRIVATE',
  6: 'OTHERS',
};
